import React from 'react';
import { useAuth } from './ScrapFlow/context/AuthContext';

export default function ProtectedRoute({ children, fallback = null }) {
  const { isAuthenticated, loading, sessionRestored } = useAuth();

  if (loading || !sessionRestored) {
    return fallback || <div style={{ padding: 24 }}><div style={{ borderRadius: 16, border: "1px solid rgba(148, 163, 184, 0.18)", padding: 16 }}><div style={{ height: 18, width: "40%", background: "rgba(148, 163, 184, 0.2)", borderRadius: 999, marginBottom: 12 }} /> <div style={{ height: 12, width: "80%", background: "rgba(148, 163, 184, 0.16)", borderRadius: 999, marginBottom: 8 }} /> <div style={{ height: 12, width: "60%", background: "rgba(148, 163, 184, 0.16)", borderRadius: 999 }} /></div></div>;
  }

  if (!isAuthenticated) {
    return fallback;
  }

  return children;
}
